import React from 'react';
import { createRoot } from 'react-dom/client';
import PreApprovedProjectsApp from './PreApprovedProjectsApp';

class PreApprovedProjectsElement extends HTMLElement {
  connectedCallback() {
    this._root = createRoot(this);
    this._root.render(<PreApprovedProjectsApp />);
  }

  disconnectedCallback() {
    this._root?.unmount();
  }
}

if (!customElements.get('scl-pre-approved-projects')) {
  customElements.define('scl-pre-approved-projects', PreApprovedProjectsElement);
}
